import { useSelector } from 'react-redux';
import type { TLanguage } from '@timeedit/types/lib/types';
import { Select } from '@timeedit/ui-components/antd';
import { languagesSelector } from '../../../slices/language.slice';

// TYPES
type Props = {
  value: string | undefined | null;
  onChange: (language: string) => void;
  placeholder: string;
  disabled?: boolean;
};

const UserLanguageSelector = ({
  value,
  onChange,
  placeholder,
  disabled = false,
}: Props) => {
  const languages = useSelector(languagesSelector);

  return (
    <Select
      size="small"
      value={value}
      onChange={(e) => onChange(e)}
      placeholder={placeholder}
      disabled={disabled}
    >
      {languages.map((l: TLanguage) => (
        <Select.Option value={l.id} key={l.id}>
          {l.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default UserLanguageSelector;
